var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "360.000000pt",
    height: "360.000000pt",
    viewBox: "0 0 360.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680 3374 c-380 -45 -635 -143 -875 -337 -329 -266 -534 -629 -585 -1041 -17 -131 -7 -390 19 -518 131 -643 598 -1117 1229 -1248 304 -63 645 -46 918 45 200 67 353 164 520 330 131 131 213 244 294 405 107 215 149 381 157 628 l6 172 -767 0 -766 0 0 -275 0 -275 435 0 c239 0 435 -3 435 -8 0 -16 -82 -147 -130 -208 -87 -108 -225 -203 -363 -248 -166 -55 -445 -60 -631 -12 -367 95 -657 384 -758 754 -32 116 -32 381 0 506 30 119 94 252 170 352 216 286 543 432 916 410 294 -16 538 -124 756 -333 l76 -72 202 202 c111 110 202 204 202 208 0 13 -190 187 -266 244 -271 204 -603 311 -994 320 -91 2 -181 1 -200 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c69c48cc13698b38f7ea506c232893d9.svg";
export { ForwardRef as ReactComponent };